import { getPaymentMethodsClient } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type { PayMethod } from '@b-stock/payments-methods-api-client'

const getAllPaymentMethods = async (entityId: string, accessToken: string) => {
  const payMethodsClient = getPaymentMethodsClient()
  const response = await payMethodsClient.getAllMethods(
    { entityId },
    buildAxiosRequestConfig({ accessToken })
  )
  return response.data.methods as PayMethod[]
}

export default getAllPaymentMethods
